import React from 'react';
import T from 'prop-types';
import AudioContext from '../audio-context';
import AudioPreview from './audio-preview';

const AudioPreviewWrapper = ({ src }) => {
  const { src: playerSrc, playing, ...restProps } = React.useContext(AudioContext);

  return <AudioPreview {...restProps} playing={playing && src === playerSrc} src={src} />;
};

AudioPreviewWrapper.propTypes = {
  src: T.string,
};

export default AudioPreviewWrapper;
